import React, { useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../../Store';
import { SlClose, SlMenu } from 'react-icons/sl';

import PrimaryNav from './PrimaryNav';
import Welcome from './Welcome';

import lottery_logo from './il-logo.png';

const Header = ({ config }) => {
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

    return (
        <header>
            <div className='promo-top'>
                <SlMenu onClick={handleNavCollapse} className='toggler-btn mobile' />
                <PrimaryNav className='desktop navbar-expand' />
                <Welcome />
            </div>
            {/* Collapsable mobile navbar */}
            <div className={`sidepanel mobile ${isNavCollapsed ? 'sidepane-close' : 'sidepane-open'}`}>
                <div className='content-panel'>
                    <PrimaryNav />
                    <Welcome />
                    <div className='logo-wr'>
                        <a href={config?.config?.lotteryHost} target='_blank' rel='noreferrer'>
                            <img src={lottery_logo} width={'50'} />
                        </a>
                    </div>
                </div>

                <div className='ver-panel'>
                    <SlClose onClick={() => setIsNavCollapsed(!isNavCollapsed)} className='closebtn' />
                </div>
            </div>
        </header>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
